import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-08d940d9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "min-vh-100 bg-light-subtle" };
const _hoisted_2 = { class: "container py-5" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "text-center mb-5 fw-light text-dark-emphasis" }, "Finalizar Pedido y Pago", -1 /* HOISTED */));
const _hoisted_4 = { class: "row g-5" };
const _hoisted_5 = { class: "col-lg-8" };
const _hoisted_6 = { class: "card shadow-lg border-0 mb-5 rounded-4" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-header text-white fw-bold border-0 rounded-top-4 p-4 header-primary-custom" }, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "h5 mb-0" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-geo-alt-fill me-2" }),
        /*#__PURE__*/ _createTextVNode(" 1. Dirección de Envío")
    ])
], -1 /* HOISTED */));
const _hoisted_8 = { class: "card-body p-4 p-md-5" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "card-title mb-4 border-bottom pb-2 fw-semibold" }, "Datos de Contacto y Ubicación", -1 /* HOISTED */));
const _hoisted_10 = { class: "row g-3" };
const _hoisted_11 = { class: "col-sm-6" };
const _hoisted_12 = { class: "form-floating" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "nombre" }, "Nombre", -1 /* HOISTED */));
const _hoisted_14 = { class: "col-sm-6" };
const _hoisted_15 = { class: "form-floating" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "whatsapp" }, "Número de WhatsApp", -1 /* HOISTED */));
const _hoisted_17 = { class: "col-12" };
const _hoisted_18 = { class: "form-floating" };
const _hoisted_19 = ["disabled"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "direccion" }, "Dirección (Calle y Número)", -1 /* HOISTED */));
const _hoisted_21 = {
    key: 0,
    class: "d-block mt-2 text-primary-custom-text"
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-info-circle-fill me-1" }, null, -1 /* HOISTED */));
const _hoisted_23 = { class: "col-12" };
const _hoisted_24 = { class: "form-floating" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "referencia" }, "Referencia / Detalles Adicionales", -1 /* HOISTED */));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "my-5" }, null, -1 /* HOISTED */));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "card-title mb-4 border-bottom pb-2 fw-semibold" }, "Ubicación en el Mapa (Google Maps)", -1 /* HOISTED */));
const _hoisted_28 = ["disabled"];
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-cursor-fill me-2" }, null, -1 /* HOISTED */));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    id: "google-map",
    style: { "width": "100%", "height": "100%" }
}, null, -1 /* HOISTED */));
const _hoisted_31 = {
    key: 0,
    class: "map-overlay-disabled"
};
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-lock-fill fs-2 mb-2" }, null, -1 /* HOISTED */));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mb-0" }, "El mapa está inactivo. Usa el botón superior para **activar el GPS** o desmárcalo para ingresar la dirección manualmente.", -1 /* HOISTED */));
const _hoisted_34 = [
    _hoisted_32,
    _hoisted_33
];
const _hoisted_35 = { class: "text-muted d-block mt-3 mb-3" };
const _hoisted_36 = {
    key: 0,
    class: "text-success ms-2"
};
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-check-circle-fill" }, null, -1 /* HOISTED */));
const _hoisted_38 = {
    key: 1,
    class: "text-danger ms-2"
};
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1 /* HOISTED */));
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */));
const _hoisted_41 = {
    key: 2,
    class: "small d-block mt-1"
};
const _hoisted_42 = { class: "card shadow-lg border-0 mb-4 rounded-4" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-header text-white fw-bold border-0 rounded-top-4 p-4 header-primary-custom" }, [
    /*#__PURE__*/ _createElementVNode("h2", { class: "h5 mb-0" }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-bank me-2" }),
        /*#__PURE__*/ _createTextVNode(" 2. Método de Pago (Transferencia)")
    ])
], -1 /* HOISTED */));
const _hoisted_44 = { class: "card-body p-4 p-md-5" };
const _hoisted_45 = {
    class: "form-check-label w-100 d-block cursor-pointer",
    for: "zelle"
};
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fw-bold fs-6 text-primary-custom-text" }, [
    /*#__PURE__*/ _createTextVNode(" Pago por Zelle "),
    /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-currency-dollar ms-2" })
], -1 /* HOISTED */));
const _hoisted_47 = {
    key: 0,
    class: "mt-4 pt-3 border-top"
};
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mb-3 text-muted small" }, "Realiza la transferencia y sube la captura de pantalla del comprobante.", -1 /* HOISTED */));
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "alert py-2 small alert-primary-custom-bg" }, " **Beneficiario:** Nombre de la Cuenta | **Email:** zelle@tutienda.com ", -1 /* HOISTED */));
const _hoisted_50 = {
    key: 0,
    class: "bi bi-cloud-arrow-up-fill fs-2 mb-2 text-primary-custom-text"
};
const _hoisted_51 = {
    key: 1,
    class: "bi bi-check-circle-fill fs-2 mb-2 text-success"
};
const _hoisted_52 = { class: "mb-1 fw-bold text-dark" };
const _hoisted_53 = { class: "text-muted" };
const _hoisted_54 = {
    key: 2,
    class: "text-danger d-block mt-2"
};
const _hoisted_55 = {
    class: "form-check-label w-100 d-block cursor-pointer",
    for: "pagoMovil"
};
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fw-bold fs-6" }, [
    /*#__PURE__*/ _createTextVNode(" Pago Móvil (Con Captura) "),
    /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-phone-fill text-success ms-2" })
], -1 /* HOISTED */));
const _hoisted_57 = {
    key: 0,
    class: "mt-4 pt-3 border-top"
};
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mb-3 text-muted small" }, "Realiza el pago móvil e ingresa los detalles y la captura.", -1 /* HOISTED */));
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-success py-2 small" }, " **Banco:** Banco Universal | **C.I.:** V-12345678 | **Teléfono:** 0414-0000000 ", -1 /* HOISTED */));
const _hoisted_60 = {
    key: 0,
    class: "bi bi-cloud-arrow-up-fill fs-2 mb-2 text-success"
};
const _hoisted_61 = {
    key: 1,
    class: "bi bi-check-circle-fill fs-2 mb-2 text-success"
};
const _hoisted_62 = { class: "mb-1 fw-bold text-dark" };
const _hoisted_63 = { class: "text-muted" };
const _hoisted_64 = {
    key: 2,
    class: "text-danger d-block mt-2"
};
const _hoisted_65 = ["disabled"];
const _hoisted_66 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_67 = {
    key: 1,
    class: "bi bi-bag-check-fill me-2"
};
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "text-center text-muted mt-2 small" }, "Al confirmar, aceptas nuestros términos y condiciones.", -1 /* HOISTED */));
const _hoisted_69 = { class: "col-lg-4" };
const _hoisted_70 = {
    class: "card shadow-lg border-0 sticky-top bg-white rounded-4",
    style: { "top": "20px" }
};
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "card-header text-white fw-bold border-0 rounded-top-4 p-4 header-primary-custom" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-receipt me-2" }),
    /*#__PURE__*/ _createTextVNode(" Resumen de Compra ")
], -1 /* HOISTED */));
const _hoisted_72 = { class: "card-body p-4" };
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h6", { class: "mb-3 text-muted" }, "Pedido #222", -1 /* HOISTED */));
const _hoisted_74 = { class: "list-group list-group-flush mb-3" };
const _hoisted_75 = { class: "text-truncate me-2" };
const _hoisted_76 = { class: "fw-semibold text-primary-custom-text" };
const _hoisted_77 = { class: "fw-semibold text-dark-emphasis" };
const _hoisted_78 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-2 border-top-0" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-muted small" }, "Costo de Envío (Estimado):", -1 /* HOISTED */));
const _hoisted_80 = { class: "fw-normal small" };
const _hoisted_81 = { class: "d-flex justify-content-between fw-bold pt-3 border-top border-2" };
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Total a Pagar:", -1 /* HOISTED */));
const _hoisted_83 = { class: "fs-4 text-primary-custom-text" };
import { ref, computed, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Header from "@/components/Header.vue";
import Swal from "sweetalert2";
import { formatCurrency } from "@/utils/formatPrice";
import { PagoService } from "@/services/PagoService";
// ---------------------------------------------------------
const initialLat = 18.4719;
const initialLon = -69.8974;
const costoEnvio = 10;
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const pedidoId = route.params.pedidoId;
        console.log("Id en pago:", pedidoId);
        // Referencias para los inputs de archivo
        const comprobanteZelle = ref(null);
        const comprobantePagoMovil = ref(null);
        const isDraggingOver = ref(null);
        // Variables de Google Maps
        let map = null;
        let marker = null;
        let geocoder = null;
        let mapInitialized = ref(false); // Nueva bandera para saber si el mapa se ha creado
        const pedido = ref(
        // SIMULACIÓN DE DATOS DE PEDIDO (Se mantiene)
        {
            pedidoId: "123",
            codigoPedido: "ABC987",
            estado: 'Pendiente',
            detalles: [
                { nombreRepuesto: "Filtro de Aceite X200", cantidadConfirmada: 2, precioVenta: 15.50, confirmado: true },
                { nombreRepuesto: "Bujía Platino GR-5", cantidadConfirmada: 4, precioVenta: 5.75, confirmado: true },
                { nombreRepuesto: "Lámpara LED H4", cantidadConfirmada: 1, precioVenta: 25.00, confirmado: false },
                { nombreRepuesto: "Pastillas de Freno Delanteras", cantidadConfirmada: 1, precioVenta: 45.00, confirmado: true },
            ]
        });
        const isLoading = ref(false);
        const isProcessing = ref(false);
        // Valores iniciales para simular coordenadas de República Dominicana (Santo Domingo)
        const form = ref({
            nombre: "",
            whatsapp: "",
            calle: "",
            referencia: "",
            metodoPago: "",
            comprobanteZelle: null,
            comprobantePagoMovil: null,
            latitud: initialLat,
            longitud: initialLon,
            ubicacionConfirmada: false,
            ubicacionFinalizada: false, // INICIA como FALSE para que el mapa esté deshabilitado
        });
        // --- Computadas y Costos (Se mantienen) ---
        const detallesConfirmados = computed(() => {
            return pedido.value?.detalles.filter(p => p.confirmado) || [];
        });
        const subtotalProductos = computed(() => {
            return detallesConfirmados.value.reduce((sum, p) => sum + p.precioVenta * p.cantidadConfirmada, 0);
        });
        const totalAPagar = computed(() => {
            return subtotalProductos.value + costoEnvio;
        });
        const isFormValid = computed(() => {
            // Nombre, whatsapp son obligatorios
            if (!form.value.nombre || !form.value.whatsapp || totalAPagar.value === 0) {
                return false;
            }
            // Si NO se usa el mapa, el campo de calle es obligatorio
            if (!form.value.ubicacionFinalizada && !form.value.calle) {
                return false;
            }
            // Validación del comprobante de pago
            if (form.value.metodoPago === 'Zelle' && !form.value.comprobanteZelle) {
                return false;
            }
            if (form.value.metodoPago === 'PagoMovil' && !form.value.comprobantePagoMovil) {
                return false;
            }
            return true;
        });
        // --- Lógica de Google Maps ---
        /**
         * Inicializa el mapa con una ubicación de centro dada.
         * Esta función ya NO pide la geolocalización.
         */
        const initMap = (center) => {
            if (typeof window.google === 'undefined' || !document.getElementById('google-map')) {
                console.error('Google Maps API no cargada.');
                return;
            }
            // Si el mapa ya está inicializado, solo re-centramos y actualizamos el marcador
            if (mapInitialized.value && map && marker) {
                updateMapAndMarker(center);
                map.setCenter(center);
                return;
            }
            map = new window.google.maps.Map(document.getElementById('google-map'), {
                center: center,
                zoom: 14,
                disableDefaultUI: true,
                zoomControl: true,
                gestureHandling: "cooperative"
            });
            geocoder = new window.google.maps.Geocoder();
            marker = new window.google.maps.Marker({
                position: center,
                map: map,
                draggable: form.value.ubicacionFinalizada,
                title: "Ubicación de Entrega"
            });
            // Escuchar el arrastre del marcador
            marker.addListener('dragend', () => {
                if (!form.value.ubicacionFinalizada)
                    return;
                const newPos = marker.getPosition();
                const newLocation = { lat: newPos.lat(), lng: newPos.lat() }; // Arreglar el tipo de retorno aquí
                const correctLocation = { lat: newPos.lat(), lng: newPos.lng() };
                updateMapAndMarker(correctLocation);
                reverseGeocode(correctLocation);
            });
            mapInitialized.value = true;
            // Realizar la geocodificación inversa inicial
            reverseGeocode(center);
        };
        /**
         * Pide permiso de geolocalización y luego inicializa el mapa.
         */
        const solicitarUbicacion = () => {
            if (isProcessing.value)
                return;
            // 1. Activar el mapa
            form.value.ubicacionFinalizada = true;
            // 2. Comprobar si el navegador soporta Geolocation
            if (!navigator.geolocation) {
                Swal.fire("Función no disponible", "Tu navegador no soporta la geolocalización. Por favor, ingresa tu dirección manualmente.", "error");
                return;
            }
            // 3. Solicitar la ubicación al navegador
            navigator.geolocation.getCurrentPosition((position) => {
                const userLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                // Inicializar/Actualizar el mapa con la ubicación del usuario
                initMap(userLocation);
                // Marcar como confirmada
                form.value.ubicacionConfirmada = true;
                Swal.fire({
                    title: "Ubicación Obtenida",
                    text: "Hemos detectado tu ubicación actual. Puedes ajustarla arrastrando el marcador.",
                    icon: "success",
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
            }, (error) => {
                // Manejar errores de permiso o denegación
                let errorMessage = "Error al obtener la ubicación.";
                if (error.code === error.PERMISSION_DENIED) {
                    errorMessage = "Permiso de ubicación denegado. Se usará la ubicación predeterminada.";
                    form.value.ubicacionConfirmada = false;
                }
                else if (error.code === error.POSITION_UNAVAILABLE) {
                    errorMessage = "La información de ubicación no está disponible.";
                }
                Swal.fire("Atención", errorMessage, "warning");
                // Inicializar con la ubicación predeterminada
                const defaultLocation = { lat: initialLat, lng: initialLon };
                initMap(defaultLocation);
                form.value.ubicacionConfirmada = false;
            });
        };
        /**
         * Actualiza las coordenadas del formulario y el marcador.
         */
        const updateMapAndMarker = (location) => {
            form.value.latitud = location.lat;
            form.value.longitud = location.lng;
            marker?.setPosition(location);
            // Solo actualiza los campos de dirección si el mapa está activo
            if (form.value.ubicacionFinalizada) {
                reverseGeocode(location);
            }
        };
        /**
         * Convierte coordenadas a dirección. (Se mantiene igual, solo se mueve)
         */
        const reverseGeocode = (location) => {
            if (!geocoder || !form.value.ubicacionFinalizada)
                return;
            const latlng = location;
            geocoder.geocode({ location: latlng }, (results, status) => {
                if (status === 'OK' && results && results[0]) {
                    const addressComponents = results[0].address_components;
                    const route = addressComponents.find(c => c.types.includes('route'))?.long_name || '';
                    const streetNumber = addressComponents.find(c => c.types.includes('street_number'))?.long_name || '';
                    const neighborhood = addressComponents.find(c => c.types.includes('neighborhood') || c.types.includes('locality'))?.long_name || '';
                    let newCalle = `${route} ${streetNumber}`.trim();
                    if (newCalle === '')
                        newCalle = results[0].formatted_address.split(',')[0].trim();
                    let newReferencia = `Ubicación GPS. Zona: ${neighborhood}. Dirección Completa: ${results[0].formatted_address}`;
                    form.value.calle = newCalle;
                    form.value.referencia = newReferencia;
                    form.value.ubicacionConfirmada = true;
                }
                else {
                    console.error('Reverse geocode falló debido a: ' + status);
                    form.value.calle = 'Dirección no encontrada automáticamente. Por favor, revisa.';
                    form.value.referencia = 'Lat/Lon: ' + latlng.lat.toFixed(4) + ', ' + latlng.lng.toFixed(4);
                    form.value.ubicacionConfirmada = false;
                }
            });
        };
        // --- Watches para control de la ubicación final ---
        // Observar el cambio del checkbox 'ubicacionFinalizada'
        watch(() => form.value.ubicacionFinalizada, (isFinalized) => {
            if (marker) {
                marker.setDraggable(isFinalized);
            }
            // Si se activa, PERO el mapa aún no se ha inicializado, lo inicializamos con las coordenadas por defecto
            if (isFinalized && !mapInitialized.value) {
                const defaultLocation = { lat: form.value.latitud, lng: form.value.longitud };
                initMap(defaultLocation);
                reverseGeocode(defaultLocation);
                // NO pedimos el GPS aquí. El usuario DEBE usar el botón "Usar mi Ubicación Actual" para el GPS.
            }
            // Si se activa y el mapa ya está, solo forzamos la geocodificación inversa
            else if (isFinalized && marker) {
                const currentPos = marker.getPosition();
                const location = { lat: currentPos.lat(), lng: currentPos.lng() };
                reverseGeocode(location);
            }
            // Si se desactiva, limpiamos los campos para forzar al usuario a ingresar manualmente.
            else if (!isFinalized) {
                form.value.calle = '';
                form.value.referencia = '';
            }
        });
        // --- Funciones de Archivo (Se mantienen) ---
        const setFile = (file, metodo) => {
            if (metodo === 'Zelle') {
                form.value.comprobanteZelle = file;
                if (file)
                    form.value.comprobantePagoMovil = null; // Limpiar el otro
            }
            else if (metodo === 'PagoMovil') {
                form.value.comprobantePagoMovil = file;
                if (file)
                    form.value.comprobanteZelle = null; // Limpiar el otro
            }
        };
        const handleFileUpload = (event, metodo) => {
            const target = event.target;
            setFile(target.files && target.files[0] || null, metodo);
        };
        const handleDrop = (event, metodo) => {
            isDraggingOver.value = null; // Quitar el efecto visual
            const file = event.dataTransfer?.files?.[0];
            if (file && file.type.startsWith('image/')) {
                setFile(file, metodo);
            }
            else if (file) {
                Swal.fire("Formato Incorrecto", "Por favor, sube solo archivos de imagen (JPG, PNG).", "error");
            }
        };
        const openFilePicker = (refName) => {
            const refEl = refName === 'comprobanteZelle' ? comprobanteZelle.value : comprobantePagoMovil.value;
            refEl?.click();
        };
        // --- Función de Compra (Se mantienen las validaciones) ---
        const finalizarCompra = async () => {
            if (isProcessing.value)
                return;
            // 1. VALIDACIÓN
            if (!isFormValid.value) {
                let msg = "Por favor, completa todos los campos de dirección y sube el comprobante de pago.";
                // Mensajes de validación más específicos (Se mantienen)
                if (!form.value.ubicacionFinalizada && !form.value.calle) {
                    msg = "Debes ingresar una dirección válida o usar el GPS para la ubicación.";
                }
                else if (form.value.ubicacionFinalizada && (!form.value.latitud || !form.value.longitud || !form.value.ubicacionConfirmada)) {
                    msg = "La ubicación GPS no está confirmada. Por favor, usa el botón 'Usar mi Ubicación Actual'.";
                }
                else if (!form.value.metodoPago || (form.value.metodoPago === 'Zelle' && !form.value.comprobanteZelle) || (form.value.metodoPago === 'PagoMovil' && !form.value.comprobantePagoMovil)) {
                    msg = "Debes seleccionar un método de pago y subir su comprobante.";
                }
                Swal.fire("Faltan Datos", msg, "warning");
                return;
            }
            isProcessing.value = true;
            // 2. Preparar el DTO de Pago
            const comprobanteFile = form.value.metodoPago === 'Zelle'
                ? form.value.comprobanteZelle
                : form.value.comprobantePagoMovil;
            if (!comprobanteFile) {
                Swal.fire("Error", "Error interno: Archivo de comprobante no encontrado.", "error");
                isProcessing.value = false;
                return;
            }
            const pagoDto = {
                pedidoId: parseInt(pedidoId),
                metodoPago: form.value.metodoPago,
                comprobante: comprobanteFile,
                // Datos de dirección/ubicación
                nombre: form.value.nombre,
                whatsapp: form.value.whatsapp,
                calle: form.value.calle,
                referencia: form.value.referencia,
                latitud: form.value.latitud,
                longitud: form.value.longitud,
                ubicacionFinalizada: form.value.ubicacionFinalizada,
            };
            // 3. Llamar al servicio de Pago
            try {
                const response = await PagoService.registrarPago(pagoDto);
                if (response.exito) {
                    Swal.fire({
                        title: "¡Pago Registrado!",
                        html: `El pago para el pedido #${pedido.value?.codigoPedido} ha sido registrado correctamente. Está pendiente de verificación.`,
                        icon: "success"
                    });
                    // Redirigir a la vista de confirmación
                    router.push(`/mis-pedidos`);
                }
            }
            catch (error) {
                console.error("Error al registrar pago:", error);
                // Mostrar el mensaje de error que capturó el PagoService del API
                Swal.fire("Error de Proceso", error.message || "Ocurrió un error inesperado al registrar el pago.", "error");
            }
            finally {
                isProcessing.value = false;
            }
        };
        onMounted(() => {
            // La inicialización inicial sólo es para cargar el mapa si la API ya está
            // Pero NO se hace la petición de geolocalización hasta que el usuario pulse el botón.
            const setupMap = () => {
                const defaultLocation = { lat: initialLat, lng: initialLon };
                // Inicializamos el mapa con la ubicación por defecto y deshabilitado
                initMap(defaultLocation);
                form.value.ubicacionFinalizada = false; // Asegurar que inicie desmarcado
            };
            if (window.google && window.google.maps) {
                setupMap();
            }
            else {
                const checkInterval = setInterval(() => {
                    if (window.google && window.google.maps) {
                        clearInterval(checkInterval);
                        setupMap();
                    }
                }, 100);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("div", _hoisted_8, [
                                    _hoisted_9,
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "nombre",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.value.nombre) = $event)),
                                                    placeholder: "Nombre",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, form.value.nombre]
                                                ]),
                                                _hoisted_13
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "tel",
                                                    class: "form-control",
                                                    id: "whatsapp",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.value.whatsapp) = $event)),
                                                    placeholder: "Número de WhatsApp",
                                                    required: ""
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, form.value.whatsapp]
                                                ]),
                                                _hoisted_16
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("div", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "direccion",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.value.calle) = $event)),
                                                    disabled: form.value.ubicacionFinalizada,
                                                    placeholder: "Dirección (Calle y Número)",
                                                    required: ""
                                                }, null, 8 /* PROPS */, _hoisted_19), [
                                                    [_vModelText, form.value.calle]
                                                ]),
                                                _hoisted_20,
                                                (form.value.ubicacionFinalizada)
                                                    ? (_openBlock(), _createElementBlock("small", _hoisted_21, [
                                                        _hoisted_22,
                                                        _createTextVNode(" Este campo se actualiza automáticamente con el GPS. ")
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "referencia",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.value.referencia) = $event)),
                                                    placeholder: "Referencia / Detalles Adicionales",
                                                    style: { "height": "100px" }
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, form.value.referencia]
                                                ]),
                                                _hoisted_25
                                            ])
                                        ])
                                    ]),
                                    _hoisted_26,
                                    _hoisted_27,
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-sm mb-4 py-2 px-3 btn-secondary-custom",
                                        onClick: solicitarUbicacion,
                                        disabled: isProcessing.value
                                    }, [
                                        _hoisted_29,
                                        _createTextVNode(" Usar mi Ubicación Actual ")
                                    ], 8 /* PROPS */, _hoisted_28),
                                    _createElementVNode("div", {
                                        id: "map-container",
                                        class: _normalizeClass(['map-real-container rounded-3 shadow-sm', { 'map-disabled': !form.value.ubicacionFinalizada }]),
                                        style: { "background-color": "#e9ecef", "position": "relative" }
                                    }, [
                                        _hoisted_30,
                                        (!form.value.ubicacionFinalizada)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
                                            : _createCommentVNode("v-if", true)
                                    ], 2 /* CLASS */),
                                    _createElementVNode("small", _hoisted_35, [
                                        _createTextVNode(" **Ubicación GPS actual:** "),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(['fw-semibold', form.value.ubicacionConfirmada ? 'text-success' : 'text-danger'])
                                        }, " Lat: " + _toDisplayString(form.value.latitud.toFixed(4)) + ", Lon: " + _toDisplayString(form.value.longitud.toFixed(4)), 3 /* TEXT, CLASS */),
                                        (form.value.ubicacionConfirmada)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                                _hoisted_37,
                                                _createTextVNode(" Confirmada")
                                            ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                _hoisted_39,
                                                _createTextVNode(" Pendiente de confirmar")
                                            ])),
                                        _hoisted_40,
                                        (form.value.ubicacionFinalizada)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Arrastra el marcador en el mapa para ajustar la dirección."))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(['form-check p-0 mb-4 border rounded-3 p-3 transition-shadow', form.value.metodoPago === 'Zelle' ? 'border-primary shadow-sm' : ''])
                                    }, [
                                        _createElementVNode("label", _hoisted_45, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input me-2",
                                                type: "radio",
                                                name: "metodoPago",
                                                id: "zelle",
                                                value: "Zelle",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.value.metodoPago) = $event)),
                                                required: ""
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelRadio, form.value.metodoPago]
                                            ]),
                                            _hoisted_46
                                        ]),
                                        _createVNode(_Transition, { name: "slide-fade" }, {
                                            default: _withCtx(() => [
                                                (form.value.metodoPago === 'Zelle')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                        _hoisted_48,
                                                        _hoisted_49,
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(['drag-drop-area', { 'is-dragover': isDraggingOver.value === 'Zelle', 'is-uploaded': form.value.comprobanteZelle }]),
                                                            onDragover: _cache[6] || (_cache[6] = _withModifiers(($event) => (isDraggingOver.value = 'Zelle'), ["prevent"])),
                                                            onDragleave: _cache[7] || (_cache[7] = _withModifiers(($event) => (isDraggingOver.value = null), ["prevent"])),
                                                            onDrop: _cache[8] || (_cache[8] = _withModifiers(($event) => (handleDrop($event, 'Zelle')), ["prevent"])),
                                                            onClick: _cache[9] || (_cache[9] = ($event) => (openFilePicker('comprobanteZelle')))
                                                        }, [
                                                            _createElementVNode("input", {
                                                                type: "file",
                                                                id: "comprobanteZelle",
                                                                ref_key: "comprobanteZelle",
                                                                ref: comprobanteZelle,
                                                                onChange: _cache[5] || (_cache[5] = ($event) => (handleFileUpload($event, 'Zelle'))),
                                                                accept: "image/*",
                                                                capture: "environment",
                                                                class: "d-none"
                                                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                                                            (!form.value.comprobanteZelle)
                                                                ? (_openBlock(), _createElementBlock("i", _hoisted_50))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_51)),
                                                            _createElementVNode("p", _hoisted_52, _toDisplayString(form.value.comprobanteZelle ? form.value.comprobanteZelle.name : 'Arrastra o haz click para subir el comprobante'), 1 /* TEXT */),
                                                            _createElementVNode("small", _hoisted_53, _toDisplayString(form.value.comprobanteZelle ? 'Archivo subido. Haz click para cambiar.' : 'Soporta PNG, JPG, JPEG.'), 1 /* TEXT */),
                                                            (!form.value.comprobanteZelle)
                                                                ? (_openBlock(), _createElementBlock("small", _hoisted_54, "Comprobante requerido."))
                                                                : _createCommentVNode("v-if", true)
                                                        ], 34 /* CLASS, NEED_HYDRATION */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ], 2 /* CLASS */),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(['form-check p-0 mb-3 border rounded-3 p-3 transition-shadow', form.value.metodoPago === 'PagoMovil' ? 'border-success shadow-sm' : ''])
                                    }, [
                                        _createElementVNode("label", _hoisted_55, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input me-2",
                                                type: "radio",
                                                name: "metodoPago",
                                                id: "pagoMovil",
                                                value: "PagoMovil",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.value.metodoPago) = $event))
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelRadio, form.value.metodoPago]
                                            ]),
                                            _hoisted_56
                                        ]),
                                        _createVNode(_Transition, { name: "slide-fade" }, {
                                            default: _withCtx(() => [
                                                (form.value.metodoPago === 'PagoMovil')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                        _hoisted_58,
                                                        _hoisted_59,
                                                        _createElementVNode("div", {
                                                            class: _normalizeClass(['drag-drop-area', { 'is-dragover': isDraggingOver.value === 'PagoMovil', 'is-uploaded': form.value.comprobantePagoMovil }]),
                                                            onDragover: _cache[12] || (_cache[12] = _withModifiers(($event) => (isDraggingOver.value = 'PagoMovil'), ["prevent"])),
                                                            onDragleave: _cache[13] || (_cache[13] = _withModifiers(($event) => (isDraggingOver.value = null), ["prevent"])),
                                                            onDrop: _cache[14] || (_cache[14] = _withModifiers(($event) => (handleDrop($event, 'PagoMovil')), ["prevent"])),
                                                            onClick: _cache[15] || (_cache[15] = ($event) => (openFilePicker('comprobantePagoMovil')))
                                                        }, [
                                                            _createElementVNode("input", {
                                                                type: "file",
                                                                id: "comprobantePagoMovil",
                                                                ref_key: "comprobantePagoMovil",
                                                                ref: comprobantePagoMovil,
                                                                onChange: _cache[11] || (_cache[11] = ($event) => (handleFileUpload($event, 'PagoMovil'))),
                                                                accept: "image/*",
                                                                capture: "environment",
                                                                class: "d-none"
                                                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                                                            (!form.value.comprobantePagoMovil)
                                                                ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_61)),
                                                            _createElementVNode("p", _hoisted_62, _toDisplayString(form.value.comprobantePagoMovil ? form.value.comprobantePagoMovil.name : 'Arrastra o haz click para subir el comprobante'), 1 /* TEXT */),
                                                            _createElementVNode("small", _hoisted_63, _toDisplayString(form.value.comprobantePagoMovil ? 'Archivo subido. Haz click para cambiar.' : 'Soporta PNG, JPG, JPEG.'), 1 /* TEXT */),
                                                            (!form.value.comprobantePagoMovil)
                                                                ? (_openBlock(), _createElementBlock("small", _hoisted_64, "Comprobante requerido."))
                                                                : _createCommentVNode("v-if", true)
                                                        ], 34 /* CLASS, NEED_HYDRATION */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ], 2 /* CLASS */)
                                ])
                            ]),
                            _createElementVNode("button", {
                                class: "btn btn-lg w-100 py-3 mt-4 shadow-lg-info btn-primary-custom",
                                onClick: finalizarCompra,
                                disabled: isProcessing.value || !isFormValid.value
                            }, [
                                (isProcessing.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_66))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_67)),
                                _createTextVNode(" Confirmar Pedido y Pago (" + _toDisplayString(_unref(formatCurrency)(totalAPagar.value)) + ") ", 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_65),
                            _hoisted_68
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, [
                                    _hoisted_73,
                                    _createElementVNode("ul", _hoisted_74, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detallesConfirmados.value, (detalle, index) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                key: index,
                                                class: "list-group-item d-flex justify-content-between align-items-center px-0 py-2"
                                            }, [
                                                _createElementVNode("div", _hoisted_75, [
                                                    _createElementVNode("small", _hoisted_76, _toDisplayString(detalle.cantidadConfirmada) + " x ", 1 /* TEXT */),
                                                    _createTextVNode(" " + _toDisplayString(detalle.nombreRepuesto), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(formatCurrency)(detalle.precioVenta * detalle.cantidadConfirmada)), 1 /* TEXT */)
                                            ]));
                                        }), 128 /* KEYED_FRAGMENT */)),
                                        _createElementVNode("li", _hoisted_78, [
                                            _hoisted_79,
                                            _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(formatCurrency)(costoEnvio)), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                        _hoisted_82,
                                        _createElementVNode("span", _hoisted_83, _toDisplayString(_unref(formatCurrency)(totalAPagar.value)), 1 /* TEXT */)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
